import { getSourceSite } from "@litonarefin/utils/getSourceSite";
import isEmpty from "lodash/isEmpty";

export function dateStringToMilliseconds(dateString = "") {
  // Split the date and time parts
  const [datePart, timePart, period] = dateString.split(/\s+/);
  const [day, month, year] = datePart.split("/");
  const [hour, minute] = timePart.split(":");

  // Convert hour to 24-hour format
  let hour24 = parseInt(hour, 10);
  if (period.toLowerCase() === "pm" && hour24 !== 12) {
    hour24 += 12;
  } else if (period.toLowerCase() === "am" && hour24 === 12) {
    hour24 = 0;
  }

  // Create a Date object (months are 0-indexed)
  const date = new Date(year, month - 1, day, hour24, minute);

  // Return milliseconds since Unix epoch
  return date.getTime();
}

export function removeLastChar(str = "") {
  let res = str?.charAt(str.length - 1);
  if (res === "/") {
    return str.slice(0, -1);
  } else {
    return str;
  }
}

export function getNotificationData(notifications, path) {
  const siteSource = getSourceSite();

  let fullSiteNotification, individualSiteNotification, notification;

  if (notifications?.notification_bar_settings?.full_site_notification?.is_open_notification) {
    fullSiteNotification = notifications?.notification_bar_settings?.full_site_notification;
  }

  individualSiteNotification =
    notifications?.notification_bar_settings?.individual_site_notification;

  if (!isEmpty(individualSiteNotification)) {
    let result;
    individualSiteNotification?.map((item) => {
      if (
        item?.product_page &&
        path ===
          removeLastChar(item?.product_page).replace(
            `${process.env.NEXT_PUBLIC_WORDPRESS_SITE_URL}/${siteSource}_page/`,
            ""
          )
      ) {
        result = item;
      }
    });

    if (!isEmpty(result) && !!result?.is_open_notification) {
      notification = result;
    } else {
      notification = fullSiteNotification;
    }
  } else {
    notification = fullSiteNotification;
  }

  return { fullSiteNotification, individualSiteNotification, notification };
}

export function checkRepeatDay(start_time, end_time, repeat_day) {
  const startTimeNum = dateStringToMilliseconds(start_time);
  const endTimeNum = dateStringToMilliseconds(end_time);

  const dayCompare = endTimeNum - startTimeNum;

  const dayMs = +repeat_day * 86400000; // 1day

  if (dayCompare <= dayMs) return endTimeNum;
  const numberOfDays = dayCompare / dayMs;

  for (let i = 1; i <= numberOfDays; i++) {
    if (new Date().getTime() < startTimeNum + i * dayMs) {
      return startTimeNum + i * dayMs;
    }
  }

  return endTimeNum;
}
